/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { forwardRef, type JSX } from "react";

import { spacing } from "../../../../../../global/emotion";
import type { HallowElement } from "../../../../../types/hallowElement.types";
import { determineChildrenInject } from "../../../../../utils/determineChildrenInject";
import { determineElementFromAsChild } from "../../../../../utils/determineElementFromAsChild";
import { Author } from "../../../_core/Author/Author.emotion";
import { CampaignLarge } from "../CampaignLarge/CampaignLarge.emotion";
import type { CampaignLargeWithAuthorProps } from "../CampaignLargeWithAuthor/CampaignLargeWithAuthor.emotion";

const hallowElement: HallowElement = "div";

const determinedElementStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
};

export type GivingCampaignLargeWithHostProps = CampaignLargeWithAuthorProps;

export const GivingCampaignLargeWithHost = forwardRef<
  any,
  GivingCampaignLargeWithHostProps
>(
  (
    {
      asChild = false,
      authorProps,
      campaignId,
      campaignName,
      campaignLargeProps,
      color,
      children,
      description,
      illustrationImgSrc,
      imgSrc,
      item,
      joined,
      hasEnded,
      section,
      tags,
      title,
      ...props
    },
    ref,
  ) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    const determinedChildren = determineChildrenInject({
      afterChildrenInject: [
        <Author
          key="author"
          labelMessage={"community_hosted_by"}
          {...authorProps}
        />,
        <CampaignLarge
          color={color}
          description={description}
          illustrationImgSrc={illustrationImgSrc}
          imgSrc={imgSrc}
          joined={joined}
          key="campaign"
          tags={tags}
          title={title}
          {...campaignLargeProps}
        />,
      ],
      children: children as JSX.Element,
    });

    return (
      <DeterminedElement ref={ref} css={determinedElementStyle} {...props}>
        {determinedChildren}
      </DeterminedElement>
    );
  },
);

GivingCampaignLargeWithHost.displayName = "GivingCampaignLargeWithHost";
